import React from "react";
import "./FullWidthImageSection.css";
import leftimg from "../Assets/cow-left.png";
import grassimg from "../Assets/grass.png";
import kidsimg from "../Assets/kids-right.png";

export default function FullWidthImageSection() {
  return (
    <section className="vangal-fullwidth-wrapper">
      <div className="vangal-fullwidth-container">
        
        {/* Left Cow Image */}
        <img
          src={leftimg}
          alt="Cow"
          className="vangal-fullwidth-left-img anim anim-top"
        />

        {/* Grass Background */}
        <img
          src={grassimg}
          alt="Grass Background"
          className="vangal-fullwidth-grass-img anim anim-bottom"
        />

        {/* Right Kids Image */}
        <img
          src={kidsimg}
          alt="Kids with Milk"
          className="vangal-fullwidth-right-img anim anim-top"
        />
      </div>
    </section>
  );
}
